"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _actions = _interopRequireDefault(require("../../optinentries/actions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ShowMyOptins extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      optins: {
        fetched: false
      }
    });
  }
  componentDidMount() {
    this.props.getMyOptins(false).then(response => {
      this.setState({
        optins: {
          ...this.state.optins,
          data: response,
          fetched: true
        }
      });
    });
  }
  render() {
    const {
      children,
      ...rest
    } = this.props;
    return _react.default.cloneElement(children, {
      ...rest,
      optins: this.state.optins
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(null, {
  getMyOptins: _actions.default.getMyOptins
})(ShowMyOptins);
module.exports = exports.default;